<template>
    <div class="biz-footer">
        <div class="landing-container wrap pc">
            <div class="section">
                <div class="list">
                    <div class="item">
                        <router-link :to="{ name: 'aboutUs'}">關於我們</router-link>
                    </div>
                    <!-- <div class="item">
                        常見問題
                    </div> -->
                    <div class="item">
                        <router-link :to="{ name: 'contact'}">洽談合作</router-link>
                    </div>
                    <div class="item">
                        <a href="https://line.me/R/ti/p/%40599ncjgk" target="_blank" rel="noopener noreferrer">
                        聯絡我們
                        </a>
                    </div>
                    <div class="item socail">
                        <a href="https://www.facebook.com/%E9%A3%9B%E8%B1%AC%E7%AE%A1%E5%AE%B6-109776907595266" target="_blank" rel="noopener noreferrer">
                            <img src="@/assets/img/landingPage/home/fb.png" alt="">
                            Facebook
                        </a>
                    </div>
                    <div class="item socail">
                        <a href="https://line.me/R/ti/p/%40599ncjgk" target="_blank" rel="noopener noreferrer">
                            <img src="@/assets/img/landingPage/home/line.png" alt="">
                            LINE客服
                        </a>
                    </div>
                </div>
            </div>
            <div class="right">
                <span class="company">
                    © {{year}} 方居浩斯科技股份有限公司版權所有
                </span>
                <div class="private">
                    <router-link :to="{ name: 'bizPrivacyPolicy'}">隱私權政策</router-link>
                </div>
                <div>
                    <router-link :to="{ name: 'bizUserTerms'}">會員條款</router-link>
                </div>
            </div>
            <div class="right-mb">
                <div class="private-wrap">
                    <div class="private">
                        <router-link :to="{ name: 'bizPrivacyPolicy'}">隱私權政策</router-link>
                    </div>
                    <div>
                        <router-link :to="{ name: 'bizUserTerms'}">會員條款</router-link>
                    </div>
                </div>
                <span class="company">
                    © {{year}} 方居浩斯科技股份有限公司版權所有
                </span>
            </div>
        </div>
        <div class="landing-container wrap mb">
            <div class="section">
                <div class="list">
                    <div class="item">
                        <div class="title">
                            飛豬
                        </div>
                        <div class="sub-item">
                            <router-link :to="{ name: 'aboutUs'}">關於我們</router-link>
                        </div>
                        <div class="sub-item socail">
                            <a href="https://www.facebook.com/%E9%A3%9B%E8%B1%AC%E7%AE%A1%E5%AE%B6-109776907595266" target="_blank" rel="noopener noreferrer">
                                <img src="@/assets/img/landingPage/home/fb.png" alt="">
                            </a>
                            <a href="https://line.me/R/ti/p/%40599ncjgk" target="_blank" rel="noopener noreferrer">
                                <img src="@/assets/img/landingPage/home/line.png" alt="">
                            </a>
                        </div>
                    </div>
                    <div class="item">
                        <div class="title">
                            幫助
                        </div>
                        <!-- <div class="sub-item">
                            常見問題
                        </div> -->
                        <div class="sub-item">
                            <router-link :to="{ name: 'contact'}">洽談合作</router-link>
                        </div>
                        <div class="sub-item">
                            <a href="https://line.me/R/ti/p/%40599ncjgk" target="_blank" rel="noopener noreferrer">
                            聯絡我們
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right">
                <span class="company">
                    © {{year}} 方居浩斯科技股份有限公司版權所有
                </span>
                <div class="private">
                    <router-link :to="{ name: 'bizPrivacyPolicy'}">隱私權政策</router-link>
                </div>
                <div>
                    <router-link :to="{ name: 'bizUserTerms'}">會員條款</router-link>
                </div>
            </div>
            <div class="right-mb">
                <div class="private-wrap">
                    <div class="private">
                        <router-link :to="{ name: 'bizPrivacyPolicy'}">隱私權政策</router-link>
                    </div>
                    <div>
                        <router-link :to="{ name: 'bizUserTerms'}">會員條款</router-link>
                    </div>
                </div>
                <span class="company">
                    © {{year}} 方居浩斯科技股份有限公司版權所有
                </span>
            </div>
        </div>
    </div>
</template>
<script>
import VueQrious from 'vue-qrious'
import { mapGetters } from 'vuex'
export default {
    data () {
        return {
            size: 100,
            hostUrl: window.location.href + '?device=1',
        }
    },
    computed: {
        year: function () {
            let d = new Date();
            let year = d.getFullYear();

            return year
        },
        ...mapGetters({
            system: 'GET_DEVICE_SYSTEM',
            iosUrl: 'GET_IOS_URL',
            androidUrl: 'GET_ANDROID_URL',
        })
    },
    components: {
        VueQrious
    }
}
</script>
<style lang="scss">
    .biz-footer{
        position: relative;
        display: flex;
        justify-content: center;
        &::after{
            content: '';
            position: absolute;
            width: 100%;
            background-color: #ededed;
            height: 1px;
            top: 112px;
        }
        .wrap{
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 56px 0 42px;
            &.mb{
                display: none;
                .section{
                    position: relative;
                    display: flex;
                    align-items: center;
                    margin-bottom: 40px;
                    .list{
                        display: flex;
                        align-items: center;
                        margin-right: 39px;
                        .item{
                            color: #474342;
                            margin-right: 93px;
                            .title{
                                font-weight: bold;
                                margin-bottom: 16px;
                            }
                            .sub-item{
                                font-size: 16px;
                                margin-bottom: 21px;
                                &.socail{
                                    display: flex;
                                    align-items: center;
                                    a {
                                        display: flex;
                                        align-items: center;
                                        &:last-child{
                                            margin-left: 18px;
                                        }
                                        >img{
                                            width: 32px;
                                        }
                                    } 
                                }
                            }
                        }
                    }
                }
            }
            &.pc{
                .section{
                    position: relative;
                    display: flex;
                    align-items: center;
                    margin-bottom: 40px;
                    .list{
                        display: flex;
                        align-items: center;
                        margin-right: 39px;
                        margin-bottom: 34px;
                        .item{
                            color: #474342;
                            margin-right: 44px;
                            font-size: 16px;
                            &:last-child{
                                margin-right: 0px;
                            }
                            &.socail{
                                display: flex;
                                align-items: center;
                                a {
                                    display: flex;
                                    align-items: center;
                                    >img{
                                        width: 32px;
                                        margin-right: 12px;
                                    }
                                } 
                            }
                        }
                    }
                }
            }
            .right{
                display: flex;
                align-items: center;
                font-size: 12px;
                color: #878787;
                a{
                    color: #878787;
                }
                .private{
                    position: relative;
                    margin: 0 23px;
                    &::before{
                        content: '';
                        width: 1px;
                        height: 11px;
                        background: #878787;
                        position: absolute;
                        left: -12px;
                        top: 2px;
                    }
                    &::after{
                        content: '';
                        width: 1px;
                        height: 11px;
                        background: #878787;
                        position: absolute;
                        right: -12px;
                        top: 2px;
                    }
                }

            }
            .right-mb{
                display: none;
            }
        }
    }
    @media screen and (max-width: 1100px) {
        .biz-footer{
            .wrap{
                width: 100%;
            }
        }
    }
    @media screen and (max-width: 860px) {
        .biz-footer{
            &::after{
                display: none;
            }
            .wrap{
                flex-direction: column;
                padding: 80px 15px 42px;
                &.mb{
                    display: flex;
                    .section{
                        flex-direction: column;
                        width: 100%;
                        .list{
                            width: 375px;
                            align-items: flex-start;
                            justify-content: space-between;
                            padding: 0 53px;
                            box-sizing: border-box;
                            margin-right: unset;
                            margin-bottom: 70px;
                            .item{
                                margin-right: unset;
                                .title{
                                    margin-bottom: 16px;
                                }
                            }
                        }
                    }
                }
                &.pc{
                    display: none;
                }
                
                .right{
                    display: none;
                }
                .right-mb{
                    position: relative;
                    display: block;
                    font-size: 12px;
                    color: #878787;
                    bottom: 0px;
                    left: -16px;
                    .private-wrap{
                        display: flex;
                        align-items: center;
                        margin-bottom: 8px;
                        a{
                            color: #878787;
                        }
                        .private{
                            position: relative;
                            margin-right: 23px;
                            &::after{
                                content: '';
                                width: 1px;
                                height: 11px;
                                background: #878787;
                                position: absolute;
                                right: -12px;
                                top: 2px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/officailPage/widges/bizFooter.vue